export const toTtfbMetric = (metric) => {
    const { value } = metric;
    return {
        ttfb: Math.trunc(value),
    };
};
//# sourceMappingURL=ttfb.js.map